import { useFormik } from 'formik'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '@/config/msalConfig'
import LoginCustomSchema from './LoginSchema'
import Input from '@/components/Input'
import logo from '@/assets/img/idus-logo.png'
import Button from '@/components/Button'
import Icons from '@/assets/icons'
import { validateFormikFields } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/contexts/Auth'
import { useState } from 'react'

const Login = () => {
  const { t } = useTranslation()
  const schema = LoginCustomSchema(t)
  const { login, loginSSO } = useAuth()
  const { instance } = useMsal()
  const [isLoadingSSO, setIsLoadingSSO] = useState(false)

  const formikData = useFormik({
    initialValues: {
      login: '',
      senha: '',
    },
    validate:  values => validateFormikFields(values, schema),
    onSubmit: async values => await login(values)
  })

  const handleSSOLogin = async () => {
    try {
      setIsLoadingSSO(true)
      
      const response = await instance.loginPopup({
        ...loginRequest,
        prompt: 'login' 
      })
      
      await loginSSO({
        accessToken: response.idToken,
        account: {
          name: response.account.name || '',
          username: response.account.username,
          localAccountId: response.account.localAccountId
        }
      })
    } catch (error) {
      console.error('Erro no login SSO:', error)
    } finally {
      setIsLoadingSSO(false)
    }
  }

  // Classes para estilização do container da página
  const MainContainerStyle = "grid xl:grid-cols-2 h-screen"
  // Classes para estilização da primeira section (Adiciona background image)
  const LogoSectionStyle = "h-full bg-cover bg-center bg-login-img-md relative p-6"
  // Classes para estilização do container da img da logo (centraliza)
  const LogoContainerStyle = "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"

    return (
      <main className={MainContainerStyle}>
        <section className={LogoSectionStyle}>
          <div className={LogoContainerStyle}>
            <img src={logo} width={600} alt="LOGO CLI" />
          </div>
        </section>
        <section className='flex items-center justify-center'>
          <form className='max-w-xl w-full p-6' onSubmit={formikData.handleSubmit} autoComplete='off'>
            <div className='flex flex-col gap-4 mb-8'>
              <h1 className='font-medium text-xl text-center'>{t('login.title')}</h1>
              <Input 
                id='user'
                label={t('login.input.user')}
                error={formikData.errors.login && formikData.touched.login ? formikData.errors.login : ''}
                {...formikData.getFieldProps('login')}
              />
              <Input 
                id='password'
                label={t('login.input.password')}
                error={formikData.errors.senha && formikData.touched.senha ? formikData.errors.senha : ''}
                type='password'
                {...formikData.getFieldProps('senha')}
              /> 
              <div className='flex items-center my-4'>
                <div className='flex-1 border-t border-gray-300'></div>
                <span className='px-4 text-sm text-gray-500'>ou</span>
                <div className='flex-1 border-t border-gray-300'></div>
              </div>
              <div className='
                  w-full
                  flex
                  items-center
                  justify-center
                  '>
              <Button 
                color='primario' 
                icon={<Icons.Microsoft pathStyle='fill-inherit'/>}
                onClick={handleSSOLogin}
                label="Entrar com Microsoft"
                disabled={isLoadingSSO || formikData.isSubmitting}
                type='button'
              />
             </div>
            </div>
            <div className='flex justify-between'>
              <Button 
                color='primario'
                icon={<Icons.SyncLock pathStyle='fill-inherit'/>}
                label={t('login.btn.forgottenPasswd')}
                type='button'
              />
              <Button 
                color='primario' 
                icon={<Icons.ArrowRight pathStyle='fill-inherit'/>}
                label={t('login.btn.enter')}
                disabled={formikData.isSubmitting}
                type='submit'
              />
            </div>
          </form>
        </section>
      </main>
    )
  }
  
  export default Login